
const FancyActionTypes = {
    
    NOTIFICATION_ADD: 'NOTIFICATION_ADD',
    NOTIFICATION_REQUEST_EXISTS: 'NOTIFICATION_REQUEST_EXISTS',    
    NOTIFICATION_REQUEST_UNAVAILABLE: 'NOTIFICATION_REQUEST_UNAVAILABLE',
    NOTIFICATION_REQUEST_AVAILABLE: 'NOTIFICATION_REQUEST_AVAILABLE',
    NOTIFICATION_REQUEST_LIVE: 'NOTIFICATION_REQUEST_LIVE',    
    NOTIFICATION_REQUEST_UPDATE: 'NOTIFICATION_REQUEST_UPDATE',    
    NOTIFICATION_MENTOR_REQUEST_UNAVAILABLE: 'NOTIFICATION_MENTOR_REQUEST_UNAVAILABLE',
    NOTIFICATION_MENTOR_REQUEST_AVAILABLE: 'NOTIFICATION_MENTOR_REQUEST_AVAILABLE',
    NOTIFICATION_MENTOR_REQUEST_EXISTS: 'NOTIFICATION_MENTOR_REQUEST_EXISTS',
    NOTIFICATION_FORUM_COMMENT: 'NOTIFICATION_FORUM_COMMENT',
    NOTIFICATION_FORUM_POST: 'NOTIFICATION_FORUM_POST',    
    NOTIFICATION_CLEAR: 'NOTIFICATION_CLEAR',    
    NOTIFICATION_LIVE_ADD: 'NOTIFICATION_LIVE_ADD',
    NOTIFICATION_CLAIMED_REQUEST_EXISTS: 'NOTIFICATION_CLAIMED_REQUEST_EXISTS',
    NOTIFICATION_MY_REQUEST_EXISTS: 'NOTIFICATION_MY_REQUEST_EXISTS',    
    NOTIFICATION_API_REQUESTS: 'NOTIFICATION_API_REQUESTS',
    
    /* quiz stuff */
    QUIZ_LIST: 'QUIZ_LIST',
    QUIZ_RESULT_LIST: 'QUIZ_RESULT_LIST',
    NOTIFICATION_QUIZ_UPDATED: 'NOTIFICATION_QUIZ_UPDATED',
    NOTIFICATION_QUIZ_ACTIVATED: 'NOTIFICATION_QUIZ_ACTIVATED',
    NOTIFICATION_QUIZ_DEACTIVATED: 'NOTIFICATION_QUIZ_DEACTIVATED',    
    NOTIFICATION_QUIZ_PASSED: 'NOTIFICATION_QUIZ_PASSED',
    NOTIFICATION_QUIZ_FAILED: 'NOTIFICATION_QUIZ_FAILED',

    // ASSISTANT_PROGRESS_QUIZ_AVAILABLE: 'ASSISTANT_PROGRESS_QUIZ_AVAILABLE',    
    // ASSISTANT_PROGRESS_SET_IS_ODO: 'ASSISTANT_PROGRESS_SET_IS_ODO',
    // ASSISTANT_PROGRESS_SET_IS_NOT_ODO: 'ASSISTANT_PROGRESS_SET_IS_NOT_ODO',
    // ASSISTANT_PROGRESS_SET_IS_MANAGER: 'ASSISTANT_PROGRESS_SET_IS_MANAGER',
    // ASSISTANT_PROGRESS_SET_IS_NOT_MANAGER: 'ASSISTANT_PROGRESS_SET_IS_NOT_MANAGER',
    // ASSISTANT_PROGRESS_SET_AVATAR_URL: 'ASSISTANT_PROGRESS_SET_AVATAR_URL',
    // ASSISTANT_PROGRESS_SET_DISPLAY_NAME: 'ASSISTANT_PROGRESS_SET_DISPLAY_NAME',
    // ASSISTANT_PROGRESS_SET_IS_FH: 'ASSISTANT_PROGRESS_SET_IS_FH',
    // ASSISTANT_PROGRESS_SET_IS_NOT_FH: 'ASSISTANT_PROGRESS_SET_IS_NOT_FH',

    USER_INFO_LOAD: 'USER_INFO_LOAD',
    
    STATS_UPDATE_ACTIVE_BY_PERMISSION: 'STATS_UPDATE_ACTIVE_BY_PERMISSION',

    CHAT_ADD: 'CHAT_ADD',
    CHAT_SET_CHANNEL: 'CHAT_SET_CHANNEL',
    CHAT_SEND_SUCCESS: 'CHAT_SEND_SUCCESS',
    CHAT_SEND_FAILURE: 'CHAT_SEND_FAILURE',
    CHAT_SENDING: 'CHAT_SENDING',    

    PROJECT_LIST: 'PROJECT_LIST',
    PROJECT_INFO: 'PROJECT_INFO',        
    PROJECT_SET: 'PROJECT_SET',
    PROJECT_ADD_TASK: 'PROJECT_ADD_TASK',
    PROJECT_REMOVE_TASK: 'PROJECT_REMOVE_TASK',
    PROJECT_METRICS_LOAD: 'PROJECT_METRICS_LOAD',
    PROJECT_OAO_UPDATED: 'PROJECT_OAO_UPDATED',
    PROJECT_USER_LIST: 'PROJECT_USER_LIST',
    PROJECT_CONVERSATION_LIST: 'PROJECT_CONVERSATION_LIST',        
    
    ODO_APPLICATION_COUNT: 'ODO_APPLICATION_COUNT',
    ODO_APPLICATION_LIST: 'ODO_APPLICATION_LIST',    
    ODO_APPLICATION_APPROVED: 'ODO_APPLICATION_APPROVED',
    ODO_APPLICATION_DENIED: 'ODO_APPLICATION_DENIED',
    ODO_APPLICATION_INVITED: 'ODO_APPLICATION_INVITED',    

    REQUEST_LIVE_COUNT: 'REQUEST_LIVE_COUNT'

};

export default FancyActionTypes;
